<template>
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.75187 18.1485C8.28324 17.6799 8.28324 16.9201 8.75186 16.4515L12.7033 12.5L8.75186 8.54853C8.28323 8.0799 8.28323 7.3201 8.75186 6.85147C9.22049 6.38284 9.98029 6.38284 10.4489 6.85147L15.2489 11.6515C15.7176 12.1201 15.7176 12.8799 15.2489 13.3485L10.4489 18.1485C9.98029 18.6172 9.22049 18.6172 8.75187 18.1485Z" fill="#7A9EB8"/>
    </svg>
</template>
